export default __webpack_public_path__ + "static/media/cprofile2.c4e3805e.png";